module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAAGFBMVEUAAAA0PkYyPEQ1PkYzPEUzZmYyPEVAQIA1nQk7AAAACHRSTlMAgP9XrgWtBOa9qiQAAAB3SURBVHja7ZgxCsAwDMR6TtL+/8eFDl06uSDIID1AAuPpDhERkR8ksL8qsB8tpB4C+tFC6mXA/rn069evX79+/fp7/j60v2h/0X4+wJ+ILvBv2iyc19Fkw8KyYMGCBQsWvoVpYYvC4GdNtBB+WkYLwed9ERGRPjdC6QnFkNHZewAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/left.png
// module id = 0p8A
// module chunks = 0